import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { ArrowLeft, GraduationCap } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TeacherSignUp() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', phone: '', password: '', school_name: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.password) {
      toast.error('Please fill all required fields');
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/signup/teacher`, form, { withCredentials: true });
      localStorage.setItem('mt_token', res.data.token);
      toast.success('Welcome, Teacher!');
      window.location.href = '/teacher';
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Signup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#FFF8F0' }}>
      <div className="p-4">
        <button onClick={() => navigate('/')} data-testid="teacher-signup-back-btn">
          <ArrowLeft className="w-5 h-5 text-[#1B4F8A]" />
        </button>
      </div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-sm">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-[#1B4F8A] rounded-2xl flex items-center justify-center mx-auto mb-3">
              <GraduationCap className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-extrabold text-[#1B4F8A]">Teacher Signup</h1>
            <p className="text-sm text-slate-500 mt-1">Create your teacher account</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-3">
            <Input data-testid="teacher-name-input" placeholder="Full Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="rounded-2xl border-2 border-[#E5DACE] px-4 py-3 font-bold" />
            <Input data-testid="teacher-phone-input" placeholder="Phone Number" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} className="rounded-2xl border-2 border-[#E5DACE] px-4 py-3 font-bold" />
            <Input data-testid="teacher-password-input" type="password" placeholder="Password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} className="rounded-2xl border-2 border-[#E5DACE] px-4 py-3 font-bold" />
            <Input data-testid="teacher-school-input" placeholder="School Name (optional)" value={form.school_name} onChange={e => setForm({...form, school_name: e.target.value})} className="rounded-2xl border-2 border-[#E5DACE] px-4 py-3 font-bold" />
            <Button data-testid="teacher-signup-submit-btn" type="submit" disabled={loading} className="w-full bg-[#1B4F8A] hover:bg-[#143D6E] text-white font-extrabold rounded-full py-3 shadow-[0_4px_0_#0D2E52] active:shadow-none active:translate-y-[4px]">
              {loading ? 'Creating...' : 'Create Account'}
            </Button>
          </form>
          <p className="text-center text-sm text-slate-500 mt-4">
            Already have an account? <Link to="/login" className="font-bold text-[#FF6B35]">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
